import * as React from "react";
import * as ReactDOM from "react-dom";
import preloadFont from "../helpers/preloadFont";
import ConfigContext from "../context/ConfigContext";
import { EngagementConfiguration } from "../types";

interface ConfigExtension {
  config: EngagementConfiguration;
}

interface IFramePortalProps {
  head?: any;
  style?: React.CSSProperties;
  children?: React.ReactNode;
}

const srcDoc = `<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <meta http-equiv="X-UA-Compatible" content="ie=edge">
</head>
<body id="velaro-container-body">
</body>
</html>`;

class IFramePortal extends React.Component<
  IFramePortalProps & ConfigExtension,
  {}
> {
  node: HTMLIFrameElement;
  head: HTMLHeadElement;
  body: HTMLElement;

  componentDidMount() {
    this.node.addEventListener("load", this.handleLoad);
  }

  componentWillUnmout() {
    this.node.removeEventListener("load", this.handleLoad);
  }

  handleLoad = async () => {
    // srcdoc isn't valid in IE. If we see the body doesn't have an id attribute,
    // we can assume srcdoc wasn't supported.

    if (!this.node.contentDocument.body.id) {
      this.node.contentDocument.write(srcDoc);
    }

    this.head = this.node.contentDocument.head;
    this.body = this.node.contentDocument.body;
    await preloadFont(this.node.contentWindow, this.props.config.Font);
    this.forceUpdate();
  };

  render() {
    const { head, children, style } = this.props;
    return (
      <iframe
        srcDoc={srcDoc}
        ref={node => (this.node = node)}
        style={style}
        title="Velaro Live Chat"
      >
        {this.head && ReactDOM.createPortal(head, this.head)}
        {this.body && ReactDOM.createPortal(children, this.body)}
      </iframe>
    );
  }
}

export default (props: IFramePortalProps) => (
  <ConfigContext.Consumer>
    {config => <IFramePortal config={config} {...props} />}
  </ConfigContext.Consumer>
);
